export class ParticleSettings{

    public static readonly splash:any = {
        "alpha": {
            "start": 1,
            "end": 0.16
        },
        "scale": {
            "start": 0.2,
            "end": 0.5,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 400,
            "end": 10,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 20,
        "startRotation": {
            "min": 30,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 0.1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 50,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    }

    public static readonly fountain:any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 1,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 650,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1600
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.04,
        "emitterLifetime": 1,
        "maxParticles": 5,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly fountain2:any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.8,
            "end": 0.8,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 650,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1600
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.04,
        "emitterLifetime": 1,
        "maxParticles": 20,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly fountain3:any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.6,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 650,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1600
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.04,
        "emitterLifetime": -1,
        "maxParticles": 6,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly fountain_nuts:any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.8,
            "end": 0.8,
            "minimumScaleMultiplier": 1.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 650,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1600
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.04,
        "emitterLifetime": -1,
        "maxParticles": 500,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly Burst3:any = 
    {
        "alpha": {
            "start": 0.42,
            "end": 1
        },
        "scale": {
            "start": 0.42,
            "end": 1.49,
            "minimumScaleMultiplier": 3.25
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 500,
            "end": 600,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 20,
        "startRotation": {
            "min": 10,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 100,
            "max": 100
        },
        "lifetime": {
            "min": 2,
            "max": 4
        },
        "blendMode": "normal",
        "frequency": 0.02,
        "emitterLifetime": 0.38,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "point"
    }

    public static readonly Burst2:any = {
        "alpha": {
            "start": 0.42,
            "end": 1
        },
        "scale": {
            "start": 0.18,
            "end": 0.46,
            "minimumScaleMultiplier": 3
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 200,
            "end": 400,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 15,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 100,
            "max": 400
        },
        "lifetime": {
            "min": 1,
            "max": 2
        },
        "blendMode": "normal",
        "frequency": 0.011,
        "emitterLifetime": 0.3,
        "maxParticles": 34,
        "pos": {
            "x": 6,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "point"
    }

    public static readonly Burst:any = {
        "alpha": {
            "start": 1,
            "end": 0.55
        },
        "scale": {
            "start": 0.7,
            "end": 0.4,
            "minimumScaleMultiplier": 1.1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 200,
            "end": 200,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 1,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": -300,
            "max": 300
        },
        "lifetime": {
            "min": 2,
            "max": 2
        },
        "blendMode": "normal",
        "frequency": 0.05,
        "emitterLifetime": -1,
        "maxParticles": 30,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "burst",
        "particlesPerWave": 5,
        "particleSpacing": 0,
        "angleStart": 0
    }

    public static readonly Mid:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.01,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 50,
            "end": 1,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 30,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 20,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    };

    public static readonly High:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.01,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 50,
            "end": 1,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 30,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 20,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    };

    public static readonly BigWin:any =    {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.3,
            "end": 0.35,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 250,
            "end": 350,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.45,
        "emitterLifetime": -1,
        "maxParticles": 30,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": 0,
            "y": 0,
            "w": 900,
            "h": 0
        }
    }

    public static readonly SuperWin:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.2,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 250,
            "end": 350,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.35,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    public static readonly MegaWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.2,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 350,
            "end": 450,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.3,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }
    
    public static readonly EpicWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.2,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 400,
            "end": 500,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.25,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    public static readonly WickedWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.2,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 400,
            "end": 500,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.2,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    public static readonly ManiacWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.4,
            "end": 0.5,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 800,
            "end": 800,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 85,
            "max": 95
        },
        "noRotation": true,
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "add",
        "frequency": 0.22,
        "emitterLifetime": -1,
        "maxParticles": 100,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -600,
            "w": 900,
            "h": 0
        }
    }
}